import React from 'react';
import ClockIllustration from 'icons/illo-clock-homepage.svg';

const ProcessingScreen = () => (
  <div className="processing-screen text-center">
    <img alt="Clock illustration" className="margin-bottom-40px" src={ClockIllustration} />
    <h4>Thanks!</h4>
    <div>Just one moment.</div>
  </div>
);

export default ProcessingScreen;
